import { OreMessageBar } from '@edenredespana/oreneta'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { AccountingStatusModal, AccountingStatusModalActions } from '@/Contract/ui/atoms'
import { useAccountingStatus } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'

interface AccountingStatusBannerProps {
  origin: string
}

export const AccountingStatusBanner = ({
  origin,
}: AccountingStatusBannerProps): JSX.Element | null => {
  const accountingStatusModalRef = useRef<AccountingStatusModalActions>(null)
  const { t } = useTranslation()

  const { accountingStatus } = useAccountingStatus()

  if (accountingStatus.debtAmount === 0) return null

  return (
    <>
      <OreMessageBar color={accountingStatus.isBlocked ? 'error' : 'warning'}>
        {accountingStatus.isBlocked
          ? t(contractTranslation.accountingStatus.blocked)
          : t(contractTranslation.accountingStatus.warned)}
        <a
          data-testid="accountingStatusLink"
          href="#"
          onClick={e => {
            e.preventDefault()
            accountingStatusModalRef?.current?.open(accountingStatus.debtAmount, origin)
          }}
        >
          {t(contractTranslation.accountingStatus.link)}
        </a>
      </OreMessageBar>
      <AccountingStatusModal ref={accountingStatusModalRef} />
    </>
  )
}
